import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { BaseInventoryLabelStackContentViewModel } from './base-inventory-label-stack-content-view-model';
import { PrintLabelContentComponent } from '../../print-label-content.component';

@Component({
  selector: 'app-base-inventory-label-stack-content',
  templateUrl: './base-inventory-label-stack-content.component.html',
  styleUrls: ['./base-inventory-label-stack-content.component.scss'],
  providers: [BaseInventoryLabelStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BaseInventoryLabelStackContentComponent extends PrintLabelContentComponent {
  constructor(
    public viewModel: BaseInventoryLabelStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
